import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { toResponseError, type VideoAddInput, type VideoAddSuccess } from '@terros/common'

export function useAddVideo(): AddHookResponse<VideoAddInput, VideoAddSuccess> {
  const mutation = useTantalimMutation<VideoAddInput, VideoAddSuccess>({
    url: '/video/add',
  })

  async function add(input: VideoAddInput): Promise<VideoAddSuccess> {
    try {
      return await mutation.mutateAsync(input)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
